import { commonSubtypes, CustomerSubtypes, getClientCookie, trackEvent, type sendEventProps } from '@repo/utils';

const getUserId = async (): Promise<string | undefined> => {
  if (typeof window !== 'undefined') {
    return getClientCookie('userId-customer');
  } else {
    const { cookies } = await import('next/headers');
    const cookieStore = cookies();
    return (await cookieStore).get('userId-customer')?.value;
  }
};

/**
 * Sends an event with the specified type and data to New Relic for the
 * customer app.
 *
 * @param {event} event - Object containing the type of event and the data to be
 *                       sent.
 */

export const sendCustomerEvent = async (
  event: Omit<sendEventProps, 'app'> & { subtype?: CustomerSubtypes | commonSubtypes },
) => {
  const userId = (await getUserId()) || 'anonymous';

  const updatedEvent = {
    ...event,
    data: {
      userId,
      ...event.data,
    },
  };

  trackEvent({ app: 'customer', ...updatedEvent });
};
